module.exports = __webpack_public_path__ + "img/cam_4_on.cd516a30.png";